var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hero-page'),_c('our-story'),_c('div',{staticClass:"ring bgg"}),_c('venue-page'),_c('gallery-page'),_c('gift-page'),_c('foot-page')],1)}
var staticRenderFns = []

export { render, staticRenderFns }